import React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { getFormattedCurrency, getFormattedNumber, formatDate } from "../utils";

const Column = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cccccc;
  padding: 0.15rem 0;
  align-items: flex-start;
`;
const Label = styled.span`
  color: #6e6e6e;
  font-weight: 400;
  font-size: 0.875rem;
  text-align: left;
`;

const Value = styled(Label)`
  color: #111111;
  text-align: right;
`;


const VALUE_RENDERER = {
    number: (value) => getFormattedNumber(value),
    date: (value) => formatDate(value),
    currency: (value) => getFormattedCurrency(value),
    default: (value) => value,
  };

const ListingInformation = ({ listing = {} }) => {
  const sectionDetails = listing?.ReportFields?.Sections?.find(
    ({ Title }) => Title === "Listing_Details_CARD"
  );

  const column1 = sectionDetails?.Column1 ?? [];
  const column2 = sectionDetails?.Column2 ?? [];

  const renderColumn = useCallback(
    ({ Label: columnLabel, Value: columnValue, Id, Type }) => {
	
	const renderer = VALUE_RENDERER[Type] ?? VALUE_RENDERER.default;
    const formattedValue = renderer(columnValue);
    return (
        <Column key={Id}>
          <Label>{columnLabel}:</Label>
          <Value>{formattedValue}</Value>
        </Column>
      );
    },
    []
  );

  if (!sectionDetails) return null;
  return (
    <>
      <div className="row mb-2">
        <div className="col-lg-6">{column1.map(renderColumn)}</div>
        <div className="col-lg-6">{column2.map(renderColumn)}</div>
      </div>
    </>
  );
};

export default ListingInformation;
